import { createFileRoute } from '@tanstack/react-router';

import { SlideshowSetupPage } from './-components/SlideshowSetupPage';

export const Route = createFileRoute('/_authenticated/slideshows/new')({
    component: SlideshowSetupPage,
});
